export default "__VITE_ASSET__TZ6feBrR__"